import * as React from "react"
import { useEffect } from "react"
import { batch } from "@preact/signals-react"
import { Box } from "@mui/material"

import { CommonFilters } from "@components"
import { COMMON_FILTER_KEYS, PRODUCT_PAGE_ROUTES } from "@constants"
import { useAppDefaultFilters } from "@hooks"
import { isLoadingCommonFilters, isSystemBusy } from "@signals"
import { productPageImageDetailsIsEmpty } from "./@signals"


export default function ProductPagesImagesDetailsFilters() {

    const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(PRODUCT_PAGE_ROUTES.IMAGE_DETAILS_ID, PRODUCT_PAGE_ROUTES.ACCESS_KEY)

    useEffect(() => {
        callUserDefaultFilters()
    }, [])

    return <Box data-tour="pp-image-details-filters">
    <CommonFilters
        components={{
            country: true, site: true,
            category: true, brand: true,
            sku: true, favFilters: true,
            skuGroup: true, favFiltersOnlyLine: true
        }}
        compProps={{
            sku: { grid: { md: 6 } },
            favFiltersOnlyLine: { grid: { md: 10 } },
            favFilters: {
                allowedFilters: [
                    COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
                    COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU
                ],
                dashboardKey: PRODUCT_PAGE_ROUTES.IMAGE_DETAILS_ID
            },
        }}
        onSubmit={() => { batch(() => {
            isLoadingCommonFilters.value = true
            productPageImageDetailsIsEmpty.value = false
            isSystemBusy.value = false
        })}}
        defaultValues={userFilters}
        isLoadingDefaultFilters={isLoadingDefaultFilters}
    />
    </Box>
}
